module.exports = __webpack_public_path__ + "img/wealth_of_knowledge.2661a304.svg";